import React from 'react';

const InfoPage: React.FC<{ onBack?: () => void }> = ({ onBack }) => (
  <div style={{
    maxWidth: 600, margin: '0 auto', padding: '2rem 1.5rem',
    background: '#111114', color: '#fff', borderRadius: 0,
    boxShadow: 'none', minHeight: '100vh', display: 'flex', flexDirection: 'column'
  }}>
    <style>{`
      @media (max-width: 768px) {
        div[style*="maxWidth: 600"] { padding: 1.5rem 1rem !important; }
      }
      @media (max-width: 480px) {
        div[style*="maxWidth: 600"] { padding: 1rem 0.8rem !important; }
        div[style*="maxWidth: 600"] h2 { font-size: 1.4rem !important; }
        div[style*="maxWidth: 600"] li { font-size: 0.9rem !important; }
      }
    `}</style>
    <button
      onClick={onBack}
      style={{
        background: 'none', border: 'none', color: '#9D4EDD', fontSize: '1.5rem',
        cursor: 'pointer', marginBottom: '1rem'
      }}
    >
      ← Back
    </button>

    <h2 style={{
      color: '#9D4EDD', marginBottom: '1.5rem', fontWeight: 800,
      letterSpacing: '0.02em', fontFamily: 'Cinzel, serif'
    }}>
      About Verlume
    </h2>

    <div style={{ fontSize: '1rem', color: '#ccc', marginBottom: '1.5rem', lineHeight: 1.8 }}>
      <p>
        <strong style={{ color: '#9D4EDD' }}>Verlume</strong> is a premium, illuminated scripture reader designed
        for deep study and reflection. Read Bible passages and LDS scriptures with beautiful typography, highlighting,
        and personal notes.
      </p>

      <h3 style={{ color: '#9D4EDD', marginTop: '1.5rem', marginBottom: '0.8rem' }}>Features</h3>
      <ul style={{ paddingLeft: '1.2rem', margin: 0 }}>
        <li>📖 30+ Bible versions</li>
        <li>⛪ LDS scriptures (Book of Mormon, D&C, Pearl of Great Price)</li>
        <li>🎤 Voice search capability</li>
        <li>🌟 Highlight and annotate verses</li>
        <li>🔍 Fast fuzzy search</li>
        <li>📱 Fully mobile-friendly design</li>
        <li>💾 Local storage of highlights and notes</li>
        <li>✨ Beautiful illuminated design</li>
      </ul>

      <h3 style={{ color: '#9D4EDD', marginTop: '1.5rem', marginBottom: '0.8rem' }}>Coming Soon</h3>
      <ul style={{ paddingLeft: '1.2rem', margin: 0 }}>
        <li>📊 Reading statistics & progress tracking</li>
        <li>📚 Study plans and daily readings</li>
        <li>🔗 Cross-references between scriptures</li>
        <li>💬 Comments from religious scholars</li>
        <li>🌍 Additional languages</li>
        <li>📱 PWA & offline reading</li>
      </ul>
    </div>

    <div style={{
      marginTop: '2rem', padding: '1.2rem', background: 'rgba(255,215,0,0.08)',
      borderLeft: '3px solid #9D4EDD', borderRadius: '4px'
    }}>
      <h3 style={{ color: '#9D4EDD', margin: '0 0 0.8rem 0' }}>Contact & Support</h3>
      <p style={{ margin: 0, fontSize: '0.95rem', color: '#ccc', lineHeight: 1.6 }}>
        Have feedback or suggestions? We'd love to hear from you!
      </p>
      <a href="mailto:support@verlume.app" style={{
        display: 'inline-flex', background: '#9D4EDD', color: '#16161B',
        padding: '0.6rem 1.2rem', borderRadius: 6, fontWeight: 700,
        fontSize: '1rem', textDecoration: 'none', marginTop: '0.8rem',
        transition: 'all 0.2s', minHeight: '44px',
        alignItems: 'center'
      }}>
        📧 support@verlume.app
      </a>
    </div>

    <div style={{
      marginTop: '1.5rem', fontSize: '0.85rem', color: '#666', textAlign: 'center'
    }}>
      <p>Version 1.5.0 • Mobile-Friendly with LDS Support</p>
    </div>
  </div>
);

export default InfoPage;
